import { serviceCardContent } from '../../data';

const initialServices = serviceCardContent.map(service => ({
    title: service.heading,
    description: service.body
}));

export default {
    name: 'servicesSectionId',
    title: 'Services Section',
    type: 'document',
    fields: [
        {
            name: 'title',
            title: 'Title',
            type: 'string',
            validation: Rule => Rule.required(),
            initialValue: 'Our Services'
        },
        {
            name: 'services',
            title: 'Services',
            type: 'array',
            of: [
                {
                    type: 'object',
                    fields: [
                        { name: 'title', title: 'Title', type: 'string', validation: Rule => Rule.required() },
                        { name: 'description', title: 'Description', type: 'text', validation: Rule => Rule.required() },
                        { name: 'image', title: 'Image', type: 'image', options: { hotspot: true }, validation: Rule => Rule.required() }
                    ]
                }
            ],
            validation: Rule => Rule.required().min(1),
            initialValue: initialServices
        }
    ],
    preview: {
        prepare() {
            return {
                title: 'Services Section',
                subtitle: 'Homepage services section'
            }
        }
    }
} 